/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Query} from './field';
import {SearchableItem} from './interface/searchable.item';
import {SearchableSelectionType} from './interface/searchable.selection';

export class ReportingPreset implements SearchableItem {
  ID: string;
  NAME: string;
  QUERY: Query;

  active: boolean;
  allowed = false;

  static parse(json: any): ReportingPreset {
    if (json) {
      const c = new ReportingPreset();

      c.ID = json.ID;
      c.NAME = json.NAME;
      c.QUERY = Query.parse(json.QUERY);

      return c;
    } else return null;
  }

  static parseArray(json: Array<any>): Array<ReportingPreset> {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(ReportingPreset.parse(j));

    return arr;
  }

  getName(): string {
    return this.NAME;
  }

  getFullDetails(): string {
    return this.NAME;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}
